import { CreateTagDto } from '@shared/common/tag/create-tag.dto';
import { IsUnique } from '@/modules/core/decorators/is-unique.decorator';
import { tagApi } from './tag.api';

export class FrontCreateTagDto extends CreateTagDto {
    @IsUnique(async (text: string, originalText: string, object: any) => {
        if (object.agencyId && text) {
            const labelAvailable = await tagApi.isLabelAvailable(
                text,
                object.agencyId,
            );

            return labelAvailable || (originalText === text);
        }

        return true;
    })
    public label!: string;
}
